import { useEffect, useState } from 'react';
import expansionRates from './constants';
import './App.css';

const contractsMap = {
  sbdo: {
    shareTokencontract: '0x0d9319565be7f53cefe84ad201be3f40feae2740',
    baseTokenContract: '0x190b589cf9Fb8DDEabBFeae36a813FFb2A702454',
    boardroomContract: '0x9d39cd20901c88030032073fb014aaf79d84d2c5',
    baseTokenName: 'BDO',
    shareTokenName: 'sBDO',
  },
  soups: {
    shareTokencontract: '0x69F27E70E820197A6e495219D9aC34C8C6dA7EeE',
    baseTokenContract: '0x94f559ae621f1c810f31a6a620ad7376776fe09e',
    boardroomContract: '0x74ee3b0c391a2190d4fc275cd6c9e9c8dc109240',
    baseTokenName: 'SOUP',
    shareTokenName: 'SOUPS',
  },
};

const getSharesTokenStaked = async (project) => {
  const sharesStakedInBoardroom = await fetch(
    `https://api.bscscan.com/api?module=account&action=tokenbalance&contractaddress=${project.shareTokencontract}&address=${project.boardroomContract}&tag=latest&apikey=${process.env.REACT_APP_API_KEY}`,
    {
      method: 'get',
      mode: 'cors',
    }
  ).then((response) => response.json());

  return Number(sharesStakedInBoardroom.result) / 10 ** 18;
};

const getTotalBaseTokenSupply = async (project) => {
  const totalBaseTokenSupply = await fetch(
    `https://api.bscscan.com/api?module=stats&action=tokensupply&contractaddress=${project.baseTokenContract}&apikey=${process.env.REACT_APP_API_KEY}`,
    {
      method: 'get',
      mode: 'cors',
    }
  ).then((respone) => respone.json());

  return Number(totalBaseTokenSupply.result) / 10 ** 18;
};

function App() {
  const [selectedShareToken, setSelectedShareToken] = useState('sbdo');
  const [totalShareTokenInBoardroom, setTotalShareTokenInBoardroom] = useState(
    0
  );
  const [totalBaseTokenSupply, setTotalBaseTokenSupply] = useState(0);
  const [shareTokenStaked, setShareTokenStaked] = useState(1);
  const [error, setError] = useState(false);

  useEffect(() => {
    getSharesTokenStaked(contractsMap[selectedShareToken])
      .then((r) => setTotalShareTokenInBoardroom(r))
      .catch((e) => setError(true));
    const interval = setInterval(() => {
      getSharesTokenStaked(contractsMap[selectedShareToken])
        .then((r) => setTotalShareTokenInBoardroom(r))
        .catch((e) => setError(true));
    }, 900000);
    return () => {
      clearInterval(interval);
    };
  }, [selectedShareToken]);
  useEffect(() => {
    getTotalBaseTokenSupply(contractsMap[selectedShareToken])
      .then((r) => setTotalBaseTokenSupply(r))
      .catch((e) => setError(true));
    const interval = setInterval(() => {
      getTotalBaseTokenSupply(contractsMap[selectedShareToken])
        .then((r) => setTotalBaseTokenSupply(r))
        .catch((e) => setError(true));
    }, 3600000);
    return () => {
      clearInterval(interval);
    };
  }, [selectedShareToken]);

  const calculateRewards = (
    expansionRate,
    bdo,
    sbdo,
    boardroomDistribution = 0.8
  ) => {
    return (
      ((bdo * expansionRate * boardroomDistribution) / sbdo) * shareTokenStaked
    );
  };

  const calculateDailyRewards = (expansionRate) => {
    let totalBDORewards = 0;
    let currentBDOTotalSupply = totalBaseTokenSupply;
    for (let i = 0; i < 4; i++) {
      totalBDORewards += calculateRewards(
        expansionRate,
        currentBDOTotalSupply,
        totalShareTokenInBoardroom
      );
      currentBDOTotalSupply += currentBDOTotalSupply * expansionRate;
    }

    return totalBDORewards;
  };

  const getExpansionRate = (shareToken) => {
    let expansionRate = 0;
    Object.keys(expansionRates[shareToken]).forEach((supply) => {
      if (totalBaseTokenSupply > supply) {
        expansionRate = expansionRates[shareToken][supply];
      }
    });

    return expansionRate;
  };

  if (error) {
    return <div>Please disable adblocker</div>;
  }

  if (!totalShareTokenInBoardroom || !totalBaseTokenSupply) {
    return <div>Loading...</div>;
  }

  return (
    <div className='App'>
      <h1 className='Information__title'>
        Calculate your {contractsMap[selectedShareToken].baseTokenName} rewards
      </h1>
      <div className='Information__selector'>
        <label htmlFor='share-token-select'>Select share token:</label>
        <select
          name='share-token'
          id='share-token-select'
          value={selectedShareToken}
          onChange={(e) => setSelectedShareToken(e.target.value)}
        >
          <option value='sbdo'>sBDO</option>
          <option value='soups'>SOUPS</option>
        </select>
      </div>
      <div className='InformationBox'>
        <div className='InformationBox__section'>
          <span className='InformationBox__section__label'>
            Total {contractsMap[selectedShareToken].shareTokenName} staked in
            Boardroom:
          </span>
          <span className='InformationBox__section__value'>
            {totalShareTokenInBoardroom}
          </span>
        </div>
        <div className='InformationBox__section'>
          <span className='InformationBox__section__label'>
            Total {contractsMap[selectedShareToken].baseTokenName} supply:
          </span>
          <span className='InformationBox__section__value'>
            {totalBaseTokenSupply}
          </span>
        </div>
        <div className='InformationBox__section'>
          <span className='InformationBox__section__label'>
            {contractsMap[selectedShareToken].baseTokenName} Rewards per epoch:
          </span>
          <span className='InformationBox__section__value'>
            {calculateRewards(
              getExpansionRate(selectedShareToken),
              totalBaseTokenSupply,
              totalShareTokenInBoardroom
            )}
          </span>
        </div>
        <div className='InformationBox__section'>
          <span className='InformationBox__section__label'>
            {contractsMap[selectedShareToken].baseTokenName} Rewards per day:
          </span>
          <span className='InformationBox__section__value'>
            {calculateDailyRewards(getExpansionRate(selectedShareToken))}
          </span>
        </div>
        <div className='InformationBox__input'>
          <label className='InformationBox__section__label'>
            Input your staked {contractsMap[selectedShareToken].shareTokenName}:
          </label>
          <input
            type='number'
            id='sbdo'
            name='sbdo'
            placeholder='1'
            value={shareTokenStaked}
            onChange={(e) => setShareTokenStaked(e.target.value)}
          />
        </div>
      </div>
      <div className="DonationSection">
        <div className='Donations'>
          If you really really like this tool and you wish you could thank your
          bro,
          you can send some crypto to the wallet below, anything's welcome
          really, especially sBDO, SOUPS and BNB xD
        </div>
        <span className='Wallet'>0x3525ceB09ea7263488f216034C680C406B0c991b</span>
      </div>
      <footer className='Footer'>
        <div className='Copyright'>Made with ❤️ by @crytpoThisBro</div>
      </footer>
    </div>
  );
}

export default App;
